module.exports = __webpack_public_path__ + "img/section-3-content_1_imgView1_img.06a8dc79.png";